import React, { useContext, useEffect, useState } from "react";
import { MainContext } from "../store/mainContext";
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
import config from "../config.json";
import './PanelMap.css'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
export default function PanelMap({ newPacket, map, listData }) {
    const { devices, setDefaultDevice, setCommand } = useContext(MainContext);
    const [listPacket, setListPacket] = useState([])
    const [search, setSearch] = useState("");
    const [listDevice, setListDevice] = useState([]);
    useEffect(() => {
        //console.log('newPacket', newPacket)
        if (newPacket == null)
            return;
        let find = devices.find(x => x.ime == newPacket.ime)
        if (find) {
            newPacket.deviceName = find.deviceName;
        }
        setListPacket([newPacket, ...listPacket])
    }, [newPacket]);

    const [filter, setFilter] = useState(0);
    useEffect(() => {
        let temp = [...listData];
        if (listData && search != "") {
            temp = listData.filter(x => x.deviceName.includes(search));
            //return;
        } else if (filter == 1) {
            temp = listData.filter(x => x.chargeSimCard != null && x.chargeSimCard > 0 && x.chargeSimCard <= 10000);
        } else if (filter == 2) {
            temp = listData.filter(x => x.battery < 5);
        } else if (filter == 3) {
            temp = listData.filter(x => {
                const seconds = Number(x.dtSpan);
                const d = Math.floor(seconds / (3600 * 24));
                const h = Math.floor(seconds % (3600 * 24) / 3600);
                //const m = Math.floor(seconds % 3600 / 60);
                //const s = Math.floor(seconds % 60);

                //const dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
                //const hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
                //const mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
                //const sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
                return d >= 3;// hDisplay + mDisplay + sDisplay;                
            });
        }
        else {
            setListDevice(listData)
            return;
        }
        setListDevice(temp);
    }, [listData, search]);

    const choiceCar = (e, item) => {
        e.preventDefault();
        setDefaultDevice(item)
    }
    const showTime = (dtSpan) => {
        const seconds = Number(dtSpan);
        const d = Math.floor(seconds / (3600 * 24));
        const h = Math.floor(seconds % (3600 * 24) / 3600);
        const m = Math.floor(seconds % 3600 / 60);
        const s = Math.floor(seconds % 60);

        const dDisplay = d > 0 ? d + " روز " : "";
        const hDisplay = h > 0 ? h + " ساعت " : "";
        //const mDisplay = m > 0 ? m + " دقیقه " : "";
        //const sDisplay = s > 0 ? s + (s == 1 ? " ,second" : " seconds") : "";
        const result = dDisplay + hDisplay;
        return (`${result}`);
    }
    const [isDoExcel, setIsDoExcel] = useState(false);
    const doExcel = async (e) => {
        e.preventDefault();
        setIsDoExcel(true);
        await noronServices.doExcelDeviceFilter({ list: listDevice.map(x => (x.id)) })
            .then(({ data }) => {
                setIsDoExcel(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                let link = document.createElement("a");
                link.setAttribute("href", 'https://api.noron1.ir/' + data.payload);
                link.setAttribute("target", "_blank");
                link.setAttribute("download", data.payload);
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => {
                setIsDoExcel(false);
            });
    }
    return (
        <>
            <div className="row">
                <div className="col" id="colGroupPanel">
                    <Tabs
                        defaultActiveKey="home"
                        id="justify-tab-example"
                        className=""
                        justify
                    >
                        <Tab eventKey="home" title="دستگاه&nbsp;ها">
                            <div className="row mt-2 mb-3">
                                <div className="col">
                                    <input
                                        type="text"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        placeholder="جستجو خودرو"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="row mt-2 mb-3">
                                <div className="col">
                                    <Dropdown as={ButtonGroup}>
                                        <Dropdown.Toggle id="dropdown-custom-1">ترتیب</Dropdown.Toggle>
                                        <Dropdown.Menu className="super-colors">
                                            <Dropdown.Item eventKey="1">نام دستگاه</Dropdown.Item>
                                            <Dropdown.Item eventKey="2">سرعت</Dropdown.Item>
                                            <Dropdown.Item eventKey="3">آخرین زمان دریافت اطلاعات</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <Dropdown
                                        as={ButtonGroup}
                                        onSelect={eventKey => {
                                            setFilter(eventKey);
                                            noronServices.hideMenu()
                                        }}>
                                        <Dropdown.Toggle id="dropdown-custom-1">فیلتر
                                            {`${filter == 0 ? "(همه)" : filter == 1 ? "(بدون شارژ)" : filter == 2 ? "(ولتاژ باتری)" : filter == 3 ? "(عدم ارسال اطلاعات)" : ""}`}</Dropdown.Toggle>
                                        <Dropdown.Menu className="super-colors">
                                            <Dropdown.Item eventKey="0" active>همه</Dropdown.Item>
                                            <Dropdown.Item eventKey="1">بدون شارژ</Dropdown.Item>
                                            <Dropdown.Item eventKey="2">کاهش ولتاژ باتری</Dropdown.Item>
                                            <Dropdown.Item eventKey="3">عدم ارسال اطلاعات طی 3 روز گذشته</Dropdown.Item>
                                            <Dropdown.Item eventKey="4"> در حال حرکت</Dropdown.Item>
                                            <Dropdown.Item eventKey="4">پارک شده</Dropdown.Item>
                                            <Dropdown.Item eventKey="5">خودرو خاموش باشد  </Dropdown.Item>
                                            <Dropdown.Item eventKey="6">خودروهای روشن</Dropdown.Item>
                                            <Dropdown.Item eventKey="7">فقط فعال</Dropdown.Item>
                                            <Dropdown.Item eventKey="8">فقط غیر فعال</Dropdown.Item>
                                            <Dropdown.Item eventKey="9">در حال حمل با جرثقیل</Dropdown.Item>
                                            <Dropdown.Item eventKey="10">فقط با درب باز</Dropdown.Item>
                                            <Dropdown.Item eventKey="11"> خودروهای سر رسید تعویض روغن </Dropdown.Item>
                                            <Dropdown.Item eventKey="12"> خودروهای سر رسید تسمه تایم </Dropdown.Item>
                                            <Dropdown.Item eventKey="13"> خودروهای سر رسید زمان سرویس دوره ای </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    {filter == 3 &&
                                        <button
                                            className="btn btn-secondary"
                                            onClick={doExcel}
                                            disabled={isDoExcel}
                                        >دانلود اکسل</button>
                                    }
                                </div>
                            </div>
                            {listDevice.map((item, index) => (
                                <div
                                    className="row border rounded mb-2  "
                                    key={index + '1'}
                                >
                                    <div className="col p-3">
                                        <Dropdown
                                            as={ButtonGroup}
                                            onSelect={e => {
                                                if (e == "4") {
                                                    toast.error("مدل دستگاه شما از این قابلیت پشتیبانی نمی کند", { theme: "colored" });
                                                    return;
                                                }
                                                console.log('eee2', e);
                                                if (map)
                                                    map.closePopup();
                                                setCommand(e);
                                            }}>
                                            <Button
                                                variant="info"
                                                onClick={e => choiceCar(e, item)}>
                                                {item.icon != "" && <img src={`${config.apiUrl}/piccar/${item.icon}`} className="imgDeviceMenuLeft" />}
                                                <span className="p-2">{item.deviceName}</span>
                                                {filter == 3 && <div className="p-2">{showTime(item.dtSpan)}</div>}
                                            </Button>
                                            <Dropdown.Toggle split variant="success" id="dropdown-custom-2" />
                                            <Dropdown.Menu className="super-colors">
                                                <Dropdown.Item eventKey={`report/${item.id}`}>تهیه گزارش</Dropdown.Item>
                                                <Dropdown.Item eventKey={`oilChangeShow/${item.id}`}>تنظیم مشخصات تعویض روغن</Dropdown.Item>
                                                <Dropdown.Item eventKey={`EditDeviceShow/${item.id}`}>اصلاح اطلاعات خودرو </Dropdown.Item>
                                                <Dropdown.Divider />
                                                <Dropdown.Item eventKey="4">شنود صدای داخل خودرو</Dropdown.Item>
                                                <Dropdown.Item eventKey="4">گرفتن عکس از داخل خودرو</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>

                            ))}
                        </Tab>
                        <Tab eventKey="profile" title="ارسال&nbsp;اطلاعات">
                            <div className="table-responsive">
                                <table className="table table-striped table-striped-columns table-bordered">
                                    <thead>
                                        <tr>
                                            <td>نام دستگاه</td>
                                            <td>زمان</td>
                                            <td>سرعت</td>
                                            <td>باطری ماشین</td>
                                            <td>باطری دستگاه</td>
                                            <td>سیگنال</td>
                                            {/*
                                            <td>درب خودرو</td>
                                            <td>شارژ سیم کارت</td>
                                            <td>سوییچ</td>
                                            <td>gps</td>
                            <td> سنسور دما</td>*/}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listPacket.map((item, index) =>
                                            <tr className="" key={index + '2'}>
                                                <td>{item.deviceName}</td>
                                                <td>{item.packets.time}</td>
                                                <td>{item.packets.speed}</td>
                                                <td>{item.packets.battery}</td>
                                                <td>{item.packets.battery2}</td>
                                                <td>{item.packets.signal}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Tab>
                        {/*
                        <Tab eventKey="longer-tab" title="تنظیمات">
                            <div className="row mt-2">
                                <div className="col">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" />
                                        <label className="form-check-label" htmlFor="flexSwitchCheckChecked">نمایش تصویر خودرو</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" />
                                        <label className="form-check-label" htmlFor="flexSwitchCheckChecked">نمایش سرعت  </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" />
                                        <label className="form-check-label" htmlFor="flexSwitchCheckChecked">فقط نمایش خودرو انتخابی  </label>
                                    </div>
                                </div>
                            </div>
                        </Tab>
*/}
                    </Tabs>
                </div>
            </div>

        </>

    );

}
